// Single source of truth for ClaimHub UK contact + regulatory copy.
// Update here once, the whole site reflects it.

export const COMPANY = {
    name: "ClaimHub UK",
    legalName: "ClaimHub UK Ltd",
    phone: "020 3728 6215",
    phoneTel: "+442037286215",
    email: "hello@claimhubuk.co.uk",
    address: {
        line1: "71-75 Shelton Street",
        line2: "Covent Garden",
        city: "London",
        postcode: "WC2H 9JQ",
        country: "United Kingdom",
    },
    addressShort: "71-75 Shelton Street, Covent Garden, London WC2H 9JQ",
    hours: "Mon – Fri · 8am – 8pm",
    regulatoryStatus: "FCA aware",
    regulatoryStatusLong: "FCA-aware claims management operations",
};
